import { ThunkDispatch } from "core-integration/src/store";
import { deleteLeague } from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import { Button } from "plos/src/components/buttons/Button";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { formItem } from "../../../LeaguesAndCups/leaguesAndCups.css";
import { deleteWrapper, header } from "./delete.css";
interface Props {
  league: IPrivateLeagueAdmin;
}

const Delete = ({ league }: Props) => {
  const { t } = useTranslation("leaguesAndCups");
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useLocalizedNavigate();

  const remove = async (leagueId: number) => {
    if (window.confirm("Are you sure you want to delete this league?")) {
      await dispatch(deleteLeague(leagueId));
      navigate("/leagues");
    }
  };

  return (
    <div className={formItem}>
      <h3 className={header}>{t("deleteLeague", "Delete League")}</h3>
      <div className={deleteWrapper}>
        <p>
          {t(
            "deleteLeagueDescription",
            "To delete the league, click on the button below. The players entered in the league will still exist and can enter other leagues if desired.",
          )}
        </p>
        <div>
          <Button onPress={() => remove(league.id)}>
            {t("deleteLeague", "Delete League")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Delete;
